// extracted by mini-css-extract-plugin
module.exports = {"favourite_btn":"AddToWishlist_favourite_btn__54_C5","disabled":"AddToWishlist_disabled__kwF30"};